<template>

  <div>
    <div class="window-header">
      <h3 class="title">
        Mensajes sobre esta solicitud ({{ messages.length }})
      </h3>
      <button
        class="button-close"
        @click="$modal.hide('funding-messages')">×
      </button>
    </div>
    <div class="modal-content">
      <div class="box-detail-investment">
        <div class="row">
          <div class="column">
            <div
              class="box-message"
              v-for="message in messages" :key="message.id">
              <p>
                <strong class="name">Fecha</strong>: {{ message.date }}
              </p>
              <div v-html="message.message"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'DashboardInvestmentFundingMessage',
  props: { messages: Array },
  data () {
    return {
    }
  }
}

</script>

<style lang="scss">

.box-message:not(:last-child) {
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #ccc;
}

</style>



// WEBPACK FOOTER //
// src/views/dashboardInvestment/DashboardInvestmentFundingMessage.vue